// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"754":"09dc2a46","788":"67f02ae6"}[chunkId] + ".chunk.js";
};